import "../scss/unicornRotateParallax.scss";
import { Parallax } from "react-scroll-parallax";

const UnicornRotateParallax = (props) => {
    let rotatingUnicorns = [];
    for (let i = 1; i < 11; i++) {
      rotatingUnicorns.push(<li key={i}> <img width="100px" height="100px" className="lazyload" data-src={require("../images/unicorns/" + i + ".png").default} alt="Suddenly Unicorns rotating a rainbow" /> </li>)
      // rotatingUnicorns.push(<li key={i}> <img width="100px" height="100px" className="lazyload no-flip" data-src={require("../images/unicorns/unrevealed_transparent.png").default} alt="Suddenly Unicorns rotating a rainbow" /> </li>)
    }

    return (
      <Parallax className="rotating-unicorns" rotate={[0, 360]} startScroll={1500} endScroll={4500}>
        <ul>
            {rotatingUnicorns}
        </ul>
      </Parallax>
    );
};

export default UnicornRotateParallax;
